import React, { FC, ReactNode } from 'react';
import Icon from '@sv-support-sdk/ui-components/src/components/Media/Icon';

import css from './style.module.scss';

interface IProps {
  children: ReactNode;
}

const ChatPlaceholder: FC<IProps> = ({ children }) => {
  return (
    <div className={css.chat__placeholder}>
      <div className={css.chat__placeholderIcon}>
        <Icon id="colored--96--block" />
      </div>
      {children}
    </div>
  );
};

export default ChatPlaceholder;
